module.exports = __webpack_public_path__ + "img/screen_4.95d5527e.svg";